const WISHLIST_TRACK_ENDPOINT = ''; // set to your endpoint URL to enable save tracking

const STORAGE_KEY = 'sigilandhide_saved';
const MAX_SHARE_ITEMS = 20;

function getList() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
}

function saveList(handles) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    return true;
  } catch {
    return false;
  }
}

function toggle(handle) {
  const list = getList();
  const idx = list.indexOf(handle);
  if (idx === -1) {
    list.push(handle);
    saveList(list);
    trackSave(handle);
  } else {
    list.splice(idx, 1);
    saveList(list);
  }
}

function isSaved(handle) {
  return getList().includes(handle);
}

function updateAllButtons() {
  const list = getList();
  document.querySelectorAll('.ma-wishlist-btn').forEach(btn => {
    const handle = btn.dataset.handle;
    const saved = list.includes(handle);
    btn.dataset.saved = saved ? 'true' : 'false';
    btn.setAttribute('aria-pressed', String(saved));
    btn.setAttribute('aria-label', saved ? 'Remove from saved' : 'Save this piece');
    btn.setAttribute('title', saved ? 'Remove from saved' : 'Save this piece');
    const label = btn.querySelector('.ma-wishlist-btn__label');
    if (label) label.textContent = saved ? 'Remove from saved' : 'Save this piece';
  });
}

function updateHeaderCount() {
  const list = getList();
  const link = document.getElementById('wishlist-icon-bubble');
  const bubble = document.getElementById('wishlist-count-bubble');
  const count = document.getElementById('wishlist-count');
  const sr = document.getElementById('wishlist-count-sr');
  if (!bubble) return;
  if (list.length === 0) {
    bubble.style.display = 'none';
    if (link) link.classList.remove('has-saved');
  } else {
    bubble.style.display = '';
    if (link) link.classList.add('has-saved');
    if (count) count.textContent = list.length;
    if (sr) sr.textContent = list.length + ' saved items';
  }
}

function buildShareURL() {
  const list = getList().slice(0, MAX_SHARE_ITEMS);
  const base = window.location.origin + '/pages/saved';
  if (list.length === 0) return base;
  return base + '?items=' + list.join(',');
}

function getURLHandles() {
  const params = new URLSearchParams(window.location.search);
  const raw = params.get('items');
  if (!raw) return [];
  return raw.split(',').map(h => h.trim()).filter(Boolean).slice(0, MAX_SHARE_ITEMS);
}

function trackSave(handle) {
  const key = 'sigilandhide_tracked_' + handle;
  if (sessionStorage.getItem(key)) return;
  sessionStorage.setItem(key, '1');

  if (WISHLIST_TRACK_ENDPOINT) {
    fetch(WISHLIST_TRACK_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ handle, timestamp: Date.now() }),
      keepalive: true
    }).catch(() => {});
  }

  if (window.fbq && window.Shopify?.customerPrivacy?.marketingAllowed?.()) {
    fbq('trackCustom', 'AddToWishlist', { content_ids: [handle], content_type: 'product' });
  }
}

function formatPrice(cents) {
  const pounds = cents / 100;
  return '£' + (Number.isInteger(pounds) ? pounds : pounds.toFixed(2));
}

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function resizeImage(url, width) {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}width=${width}`;
}

function renderSavedItem(product) {
  const imgTag = product.featured_image
    ? `<img src="${escapeHtml(resizeImage(product.featured_image, 240))}" alt="${escapeHtml(product.title)}" loading="lazy">`
    : '';
  const soldOut = !product.available
    ? '<span class="ma-saved__sold-out">Sold out</span>'
    : '';
  return `<li class="ma-saved__row" data-handle="${escapeHtml(product.handle)}">
  <a class="ma-saved__image" href="${escapeHtml(product.url)}">${imgTag}</a>
  <div class="ma-saved__info">
    <a class="ma-saved__title" href="${escapeHtml(product.url)}">${escapeHtml(product.title)}</a>
  </div>
  <p class="ma-saved__price">${formatPrice(product.price)}${soldOut}</p>
  <button class="ma-saved__remove" type="button" data-handle="${escapeHtml(product.handle)}" aria-label="Remove ${escapeHtml(product.title)} from saved" title="Remove">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m2 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"></path></svg>
  </button>
</li>`;
}

function updateCountText(countEl, count, isSharedView) {
  if (!countEl) return;
  const noun = count === 1 ? 'item' : 'items';
  const suffix = isSharedView ? 'shared list' : 'saved on this device';
  countEl.textContent = `${count} ${noun} · ${suffix}`;
}

function legacyCopy(text) {
  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    const copied = document.execCommand('copy');
    document.body.removeChild(textarea);
    return copied;
  } catch {
    return false;
  }
}

function copyLink(url) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(url).then(() => true).catch(() => legacyCopy(url));
  }
  return Promise.resolve(legacyCopy(url));
}

function showToast(toastEl, message) {
  if (!toastEl) return;
  toastEl.textContent = message;
  toastEl.hidden = false;
  clearTimeout(toastEl.dismissTimer);
  toastEl.dismissTimer = setTimeout(() => { toastEl.hidden = true; }, 2000);
}

async function initSavedPage() {
  const root = document.getElementById('ma-saved-root');
  if (!root) return;

  const grid = document.getElementById('ma-saved-grid');
  const emptyState = document.getElementById('ma-saved-empty');
  const metaBar = document.getElementById('ma-saved-meta');
  const countEl = document.getElementById('ma-saved-count');
  const clearBtn = document.getElementById('ma-saved-clear');
  const actions = document.getElementById('ma-saved-actions');
  const shareBtn = document.getElementById('ma-saved-share');
  const shareMenu = document.getElementById('ma-share-menu');
  const shareCopyBtn = document.getElementById('ma-share-copy');
  const shareEmailLink = document.getElementById('ma-share-email');
  const shareWhatsAppLink = document.getElementById('ma-share-whatsapp');
  const shareToast = document.getElementById('ma-share-toast');

  const urlHandles = getURLHandles();
  const isSharedView = urlHandles.length > 0;
  const handles = isSharedView ? urlHandles : getList();

  if (isSharedView && clearBtn) {
    clearBtn.hidden = true;
  }

  if (handles.length === 0) {
    emptyState.hidden = false;
    return;
  }

  const results = await Promise.allSettled(
    handles.map(handle =>
      fetch(`/products/${handle}.js`).then(r => {
        if (!r.ok) throw new Error('not found');
        return r.json();
      })
    )
  );

  const liveHandles = [];
  const items = [];
  results.forEach((result, i) => {
    if (result.status === 'fulfilled') {
      liveHandles.push(handles[i]);
      items.push(renderSavedItem(result.value));
    }
  });

  if (!isSharedView) {
    // Prune handles for products that no longer exist
    saveList(liveHandles);
    updateHeaderCount();
  }

  if (items.length === 0) {
    emptyState.hidden = false;
    return;
  }

  grid.innerHTML = items.join('');
  actions.hidden = false;
  if (metaBar) {
    metaBar.hidden = false;
    updateCountText(countEl, items.length, isSharedView);
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      saveList([]);
      grid.innerHTML = '';
      if (metaBar) metaBar.hidden = true;
      actions.hidden = true;
      emptyState.hidden = false;
      updateHeaderCount();
      updateAllButtons();
    });
  }

  grid.addEventListener('click', e => {
    const btn = e.target.closest('.ma-saved__remove');
    if (!btn) return;
    const handle = btn.dataset.handle;
    if (isSharedView) {
      const idx = urlHandles.indexOf(handle);
      if (idx !== -1) urlHandles.splice(idx, 1);
    } else {
      toggle(handle);
    }
    const item = grid.querySelector(`li[data-handle="${handle}"]`);
    if (item) item.remove();
    if (metaBar) updateCountText(countEl, grid.children.length, isSharedView);
    if (grid.children.length === 0) {
      emptyState.hidden = false;
      actions.hidden = true;
      if (metaBar) metaBar.hidden = true;
    }
    if (!isSharedView) {
      updateHeaderCount();
      updateAllButtons();
    }
  });

  if (shareBtn && shareMenu) {
    const closeMenu = () => {
      shareMenu.hidden = true;
      shareBtn.setAttribute('aria-expanded', 'false');
    };
    const openMenu = () => {
      const url = isSharedView ? window.location.href : buildShareURL();
      if (shareEmailLink) {
        shareEmailLink.href = 'mailto:?subject=' + encodeURIComponent('A saved list from Sigil & Hide')
          + '&body=' + encodeURIComponent('Take a look at what I found: ' + url);
      }
      if (shareWhatsAppLink) {
        shareWhatsAppLink.href = 'https://wa.me/?text=' + encodeURIComponent(url);
      }
      shareMenu.hidden = false;
      shareBtn.setAttribute('aria-expanded', 'true');
    };

    shareBtn.addEventListener('click', async () => {
      const url = isSharedView ? window.location.href : buildShareURL();
      if (navigator.share) {
        try {
          await navigator.share({ url, title: document.title });
          return;
        } catch (e) {
          if (e.name === 'AbortError') return;
          console.error('navigator.share failed, falling back to menu:', e);
        }
      }
      if (shareMenu.hidden) {
        openMenu();
      } else {
        closeMenu();
      }
    });

    if (shareCopyBtn) {
      shareCopyBtn.addEventListener('click', () => {
        const url = isSharedView ? window.location.href : buildShareURL();
        closeMenu();
        copyLink(url).then(copied => {
          showToast(shareToast, copied ? 'Copied to clipboard' : "Couldn't copy — try Email or WhatsApp instead");
        });
      });
    }

    if (shareEmailLink) shareEmailLink.addEventListener('click', closeMenu);
    if (shareWhatsAppLink) shareWhatsAppLink.addEventListener('click', closeMenu);

    document.addEventListener('click', e => {
      if (!shareMenu.hidden && !e.target.closest('#ma-share')) closeMenu();
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !shareMenu.hidden) {
        closeMenu();
        shareBtn.focus();
      }
    });
  }
}

document.addEventListener('click', e => {
  const btn = e.target.closest('.ma-wishlist-btn');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  const handle = btn.dataset.handle;
  if (!handle) return;
  toggle(handle);
  updateAllButtons();
  updateHeaderCount();
});

document.addEventListener('DOMContentLoaded', () => {
  updateAllButtons();
  updateHeaderCount();
  initSavedPage();
});
